import React, { useMemo } from "react";
import { CardAction } from "./types";

export interface ActionDefinition {
  id: string;
  label: string;
  icon: React.ReactNode;
  handler: () => void;
  disabled?: boolean;
  loading?: boolean;
  variant?: "primary" | "secondary" | "error" | "success";
  condition?: boolean; // Whether to show this action
}

interface UseCardActionsProps {
  actionDefinitions: ActionDefinition[];
  disabled?: boolean;
}

export function useCardActions({
  actionDefinitions,
  disabled = false,
}: UseCardActionsProps) {
  const actions: CardAction[] = useMemo(() => {
    return actionDefinitions
      .filter((def) => def.condition !== false) // Only include actions where condition is not explicitly false
      .map((def) => ({
        id: def.id,
        label: def.label,
        icon: def.icon,
        handler: def.handler,
        disabled: disabled || def.disabled,
        loading: def.loading,
        variant: def.variant,
      }));
  }, [actionDefinitions, disabled]);

  return {
    actions,
  };
}
